export default function PageMain({children, ...props}) {
    return (
        <div className={`pb-[15px] px-[10px] lg:px-[25px] relative bg-grey-50 min-h-[calc(100vh-96px)] overflow-y-auto ${props?.noPadding === true && '!p-0'}`}>
            {children}
        </div>
    )
}